"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var SetInitialHeight = /** @class */ (function (_super) {
    __extends(SetInitialHeight, _super);
    function SetInitialHeight() {
        var _this = _super.call(this) || this;
        _this.setHeight = function () {
            var _a;
            (_a = _this.heightElements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
                element.removeAttribute('style');
                var initialHeight = Math.ceil(element.offsetHeight);
                element.style.setProperty('height', "".concat(initialHeight, "px"));
            });
        };
        var main = document.querySelector('main');
        _this.setElement(main);
        _this.heightElements = _this.getChildElements("[".concat(constants_1.DATA_SET_INITIAL_HEIGHT, "]"));
        // Set initial height on load
        _this.setHeight();
        // Set new height on resize
        window.addEventListener('resize', function () {
            setTimeout(function () {
                _this.setHeight();
            }, 400);
        });
        return _this;
    }
    return SetInitialHeight;
}(abstractComponent_1.default));
exports.default = SetInitialHeight;
